import React, {Component, ReactElement} from 'react';
import Table, {TableColumn} from "../Table";
import IMisFetchRun from '../../models/hosted-salamander/IMisFetchRun';
import { TableRowProps } from '../TableRow';
import TableCell from "../TableCell";
import {IContainerMisFetchRun} from "../../models/hosted-salamander/IContainerMisFetchRun";
import DurationCellContent from "../DurationCellContent";

interface MisFetchRunTableProps {
    title: string;
    hostRuns?: IMisFetchRun[];
    currentHostRun?: IMisFetchRun;
}

interface MisFetchRunTableState {
}

const HOST_RUNS_COLUMNS: TableColumn[] = [    
    {
        title: "Id",
        propertyPath: "id",
        flex: 1,
        enableSort: false
    },
    {
        title: "Date",
        propertyPath: "createdDateTime",
        type: "date",
        flex: 1,
        enableSort: true
    },
    {
        title: "Version",
        propertyPath: "version",
        flex: 1
    },
    {
        title: "Duration",
        propertyPath: "duration",
        flex: 1
    },
    {
        title: "Status",
        propertyPath: "status",
        flex: 1,
        enableSort: true
    }
];

export default class MisFetchRunTable extends Component<MisFetchRunTableProps, MisFetchRunTableState> {
    static displayName = MisFetchRunTable.name;

    constructor(props: MisFetchRunTableProps) {
        super(props);

        this.state = {
        }
    }


    private cellForColumn = (item: IMisFetchRun, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined =>
    {
        if(column.propertyPath === "id")
        {
            if(item === this.props.currentHostRun)
            {
                return (
                    <TableCell key={columnIndex} flex={column.flex}>
                        <div className="pill pill--blue pill--width-fit-content">{item.id}</div>
                    </TableCell>
                );
            }
        }
        
        if(column.propertyPath === "status")
        {
            let pill: JSX.Element | null = null;
            if(item.errored === true)
            {
                pill = <div className="pill pill--red">Errored</div>;
            }
            else if(item.completed === true)
            {
                pill = <div className={"pill pill--green"}>Completed</div>;
            }

            return (
                <TableCell key={columnIndex} flex={column.flex}>
                    {pill}
                </TableCell>
            );
        }
        
        if(column.propertyPath === "version")
        {
            var containerRun = item as IContainerMisFetchRun;
            return (
                <TableCell key={columnIndex} flex={column.flex}>
                    <span>{containerRun.containerTag}</span>
                    <span className={"text-extra-detail"}>{containerRun.containerImage}</span>
                </TableCell>
            )
        }
        
        if(column.propertyPath === "duration")
        {
            return (
                <TableCell key={columnIndex} flex={column.flex}>
                    <DurationCellContent from={item.createdDateTime} to={item.completedDateTime}/>
                </TableCell>
            )
        }
    }
    
    render() {
        
        return (
            <Table
                title={this.props.title}
                enableSort={true}
                columns={HOST_RUNS_COLUMNS}
                items={this.props.hostRuns!}
                loading={this.props.hostRuns === undefined}
                rowPropsForItem={(hostRun: IMisFetchRun) => {
                    const linkUrl = `/cdb-admin/mis-fetch/${hostRun.tenantId}/${hostRun.schoolCode}/${hostRun.misDataServiceType}/runs/${hostRun.id}`;
                    return {
                        enableRowLink: true,
                        to: linkUrl
                    } as TableRowProps;
                }}
                cellForColumn={this.cellForColumn}
            >
                {this.props.children}
            </Table>
        );
    }
}
